import React from "react";
import { useStore } from "../store/Store";
import { NavLink } from "react-router-dom";

function Landing() {
  const store = useStore();

  const handleWho = (e) => {
    store.addWho(e.target.value);
  };
  return (
    <div className="container">
      <div className="complete-content">
        <h1>{store.title}</h1>
        <input
          className="whoInput"
          type="text"
          value={store.who}
          onChange={handleWho}
          placeholder="what's happening"
        />
        <div className="link-row">
          <div className="router-link">
            <NavLink to="/scan">Scan</NavLink>
          </div>
          <div className="router-link">
            <NavLink to="/note">Notes</NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
